export const replaceQuizLink = (): void => {
  const replaceInput = document.querySelector<HTMLInputElement>(
    'input[type="hidden"][name="replace-quiz-link"]'
  )
  const quizInput = document.querySelector<HTMLInputElement>(
    'input[type="hidden"][name="quiz-link"]'
  )
  if (replaceInput && quizInput) {
    const newPath = replaceInput.value
    const oldPath = quizInput.value

    const links = document.querySelectorAll<HTMLAnchorElement>('a[href]')
    links.forEach((link) => {
      const url = new URL(link.href, window.location.origin)
      if (url.pathname === oldPath) {
        url.pathname = newPath
        link.href = url.toString()
      }
    })
  }
}
